/**
 * Farmalisto Favorites System
 * Guarda favoritos en localStorage por usuario (customer ID).
 * Expone un API global: window.FarmalistoFavorites
 */
(function() {
  'use strict';

  var STORAGE_KEY_PREFIX = 'farmalisto_favorites_';

  function getStorageKey() {
    var customerId = window.__farmalistoCustomerId || 'guest';
    return STORAGE_KEY_PREFIX + customerId;
  }

  function getFavorites() {
    try {
      var data = localStorage.getItem(getStorageKey());
      return data ? JSON.parse(data) : [];
    } catch(e) {
      return [];
    }
  }

  function saveFavorites(list) {
    try {
      localStorage.setItem(getStorageKey(), JSON.stringify(list));
    } catch(e) {
      console.error('Farmalisto Favorites: Error guardando favoritos', e);
    }
  }

  function isFavorite(productId) {
    var favs = getFavorites();
    return favs.some(function(f) { return String(f.id) === String(productId); });
  }

  function addFavorite(productData) {
    var favs = getFavorites();
    if (!favs.some(function(f) { return String(f.id) === String(productData.id); })) {
      favs.push({
        id: String(productData.id),
        handle: productData.handle || '',
        title: productData.title || '',
        price: productData.price || 0,
        compare_at_price: productData.compare_at_price || 0,
        image: productData.image || '',
        url: productData.url || '',
        variant_id: productData.variant_id || '',
        available: productData.available !== undefined ? productData.available : true,
        added_at: new Date().toISOString()
      });
      saveFavorites(favs);
    }
    syncAllButtons();
    renderFavoritesTab();
  }

  function removeFavorite(productId) {
    var favs = getFavorites();
    favs = favs.filter(function(f) { return String(f.id) !== String(productId); });
    saveFavorites(favs);
    syncAllButtons();
    renderFavoritesTab();
  }

  function toggleFavorite(productData) {
    if (isFavorite(productData.id)) {
      removeFavorite(productData.id);
      return false;
    } else {
      addFavorite(productData);
      return true;
    }
  }

  /** Sincroniza TODOS los botones .f-favorites-btn en la página */
  function syncAllButtons() {
    var buttons = document.querySelectorAll('.f-favorites-btn[data-product-id]');
    buttons.forEach(function(btn) {
      var pid = btn.getAttribute('data-product-id');
      if (isFavorite(pid)) {
        btn.classList.add('active');
      } else {
        btn.classList.remove('active');
      }
    });
  }

  /** Renderiza la tabla de favoritos en la pestaña del perfil */
  function renderFavoritesTab() {
    var container = document.getElementById('farmalisto-favorites-grid');
    if (!container) return;

    var favs = getFavorites();

    if (favs.length === 0) {
      container.innerHTML =
        '<div style="padding: 40px; text-align: center;">' +
          '<h3 style="color: var(--color-brand-blue-dark); margin-bottom: 16px;">¡Prepara tu lista de deseos!</h3>' +
          '<p style="color: var(--color-neutral-base); margin-bottom: 24px;">Aún no tienes productos guardados. Explora nuestro catálogo y presiona el corazón en los productos que más te gusten.</p>' +
          '<a href="/collections/all" class="f-fav-explore-btn">Seguir explorando productos</a>' +
        '</div>';
      return;
    }

    var html = '<table class="f-fav-table">';
    html += '<thead><tr>';
    html += '<th class="f-fav-th">Producto</th>';
    html += '<th class="f-fav-th">Precio</th>';
    html += '<th class="f-fav-th">Disponibilidad</th>';
    html += '<th class="f-fav-th f-fav-th--center">Acciones</th>';
    html += '</tr></thead>';
    html += '<tbody>';

    favs.forEach(function(product, index) {
      var rowClass = index % 2 === 1 ? ' f-fav-row--alt' : '';
      var priceFormatted = formatPrice(product.price);
      var availText = product.available ? '🟢 En stock' : '🔴 Agotado';

      html += '<tr class="f-fav-row' + rowClass + '">';
      html += '<td class="f-fav-cell f-fav-cell--product">';
      html += '<div class="f-fav-product-info">';
      if (product.image) {
        html += '<img src="' + product.image + '" alt="' + escapeHtml(product.title) + '" class="f-fav-product-img" width="48" height="48">';
      }
      html += '<a href="' + product.url + '" class="f-fav-product-name">' + escapeHtml(product.title) + '</a>';
      html += '</div>';
      html += '</td>';
      html += '<td class="f-fav-cell">' + priceFormatted + '</td>';
      html += '<td class="f-fav-cell">' + availText + '</td>';
      html += '<td class="f-fav-cell order-actions-cell">';
      html += '<div class="actions-flex">';
      html += '<button class="btn-action-outline" style="flex: none; width: auto; padding: 6px 12px;" data-variant-id="' + product.variant_id + '" onclick="FarmalistoFavorites.addToCart(\'' + product.variant_id + '\', this)">';
      html += '<svg xmlns="http://www.w3.org/2000/svg" width="20" height="20" viewBox="0 0 24 24" fill="none" stroke="currentColor" stroke-width="2" stroke-linecap="round" stroke-linejoin="round"><circle cx="9" cy="21" r="1"/><circle cx="20" cy="21" r="1"/><path d="M1 1h4l2.68 13.39a2 2 0 0 0 2 1.61h9.72a2 2 0 0 0 2-1.61L23 6H6"/></svg>';
      html += '<span>Agregar al carrito</span>';
      html += '</button>';
      html += '<div style="margin:0;">';
      html += '<button class="btn-action-outline btn-cancel" style="flex: none; width: auto; padding: 6px 12px;" onclick="FarmalistoFavorites.remove(\'' + product.id + '\')">';
      html += '<svg width="20" height="20" viewBox="0 0 24 24" fill="none" stroke="currentColor" stroke-width="2"><polyline points="3 6 5 6 21 6"></polyline><path d="M19 6v14a2 2 0 0 1-2 2H7a2 2 0 0 1-2-2V6m3 0V4a2 2 0 0 1 2-2h4a2 2 0 0 1 2 2v2"></path></svg>';
      html += '<span>Eliminar</span>';
      html += '</button>';
      html += '</div>';
      html += '</div>';
      html += '</td>';
      html += '</tr>';
    });

    html += '</tbody></table>';
    html += '<div class="f-fav-footer">';
    html += '<a href="/collections/all" class="f-fav-explore-btn">Seguir explorando productos</a>';
    html += '</div>';

    container.innerHTML = html;
    container.style.padding = '0';
    container.style.textAlign = 'left';
  }

  function addToCart(variantId, btnEl) {
    if (!variantId) return;
    if (btnEl) {
      btnEl.querySelector('span').textContent = 'Agregando...';
      btnEl.disabled = true;
    }
    fetch('/cart/add.js', {
      method: 'POST',
      headers: { 'Content-Type': 'application/json' },
      body: JSON.stringify({ items: [{ id: parseInt(variantId), quantity: 1 }] })
    })
    .then(function(r) { return r.json(); })
    .then(function() {
      if (btnEl) {
        btnEl.querySelector('span').textContent = '¡Agregado! ✓';
        setTimeout(function() {
          btnEl.querySelector('span').textContent = 'Agregar al carrito';
          btnEl.disabled = false;
        }, 2000);
      }
      // Abrir cart drawer
      document.dispatchEvent(new CustomEvent('cart:updated'));
      var cartIcon = document.querySelector('a[href="/cart"], .header__icon--cart, [data-cart-toggle]');
      if (cartIcon) cartIcon.click();
    })
    .catch(function() {
      if (btnEl) {
        btnEl.querySelector('span').textContent = 'Error';
        setTimeout(function() {
          btnEl.querySelector('span').textContent = 'Agregar al carrito';
          btnEl.disabled = false;
        }, 2000);
      }
    });
  }

  function formatPrice(cents) {
    if (!cents) return '$0';
    var num = typeof cents === 'string' ? parseInt(cents) : cents;
    return '$' + num.toLocaleString('es-CO');
  }

  function escapeHtml(str) {
    var div = document.createElement('div');
    div.appendChild(document.createTextNode(str));
    return div.innerHTML;
  }

  // API pública
  window.FarmalistoFavorites = {
    get: getFavorites,
    is: isFavorite,
    add: addFavorite,
    remove: removeFavorite,
    toggle: toggleFavorite,
    sync: syncAllButtons,
    render: renderFavoritesTab,
    addToCart: addToCart
  };

  // Al cargar la página, sincronizar botones y renderizar
  document.addEventListener('DOMContentLoaded', function() {
    syncAllButtons();
    renderFavoritesTab();
  });
})();
